import { cn } from '@/lib/utils'

type BadgeVariant = 'active' | 'inactive' | 'system' | 'info' | 'warning'

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  active: 'bg-emerald-50 text-emerald-700',
  inactive: 'bg-neutral-100 text-neutral-500',
  system: 'bg-amber-50 text-amber-700',
  info: 'bg-blue-50 text-blue-700',
  warning: 'bg-orange-50 text-orange-700',
}

interface StatusBadgeProps {
  label: string
  variant?: BadgeVariant
  className?: string
}

export function StatusBadge({ label, variant = 'info', className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        VARIANT_CLASSES[variant],
        className,
      )}
    >
      {label}
    </span>
  )
}
